import { getCookie } from 'utils/cokie'
import jwt_decode from 'jwt-decode'
import { TokenHeaderModel } from 'models/TokenHeaderModel'
import store from 'redux/store'

export const FSR_ROLE = 'FSR'
export const THIRD_PARTY_SALES_USER_ROLE = 'THIRD_PARTY_SALES_USER'

export const isFSRUser = (): boolean => {
    try {
        // Try from redux state first
        const tokenHeader = store.getState()?.auth?.tokenHeader
        if (tokenHeader?.roles) {
            return tokenHeader.roles.includes(FSR_ROLE) && tokenHeader.roles.includes(THIRD_PARTY_SALES_USER_ROLE)
        }
        // Fallback to cookie
        const token = getCookie('access_token')
        if (!token) return false
        const decoded = jwt_decode(token) as TokenHeaderModel
        return decoded?.roles?.includes(FSR_ROLE) && decoded?.roles?.includes(THIRD_PARTY_SALES_USER_ROLE)
    } catch {
        return false
    }
}

/**
 * Routes allowed for FSR-only users
 */
export const FSR_ALLOWED_PATHS = [
    '/',
    '/login',
    '/third-party-login',
    '/inventoryManagement',
    '/deploymentRequests',
    '/deploymentMulti',
    '/closureRemarks',
]

export const isFSRAllowedPath = (path: string): boolean => {
    return FSR_ALLOWED_PATHS.some((allowed) => path === allowed || (allowed !== '/' && path.startsWith(allowed)))
}
